import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent, useState } from 'react';
import { Formik } from 'formik';
import PasswordValidationWidget from '../../UI/PasswordValidationWidget';
import styles from '../Login.module.scss';
import { useTranslation } from 'react-i18next';

const { TextField, Button, Box, Title } = vp;
export type PasswordFeilds = {
  Password: string;
};
type ResetPasswordFormProps = {
  handleFormSubmit: (values: PasswordFeilds, actions: any) => void;
  initialValues: PasswordFeilds;
  hasError: boolean;
  errorMsg: string;
};

type FC = FunctionComponent<ResetPasswordFormProps>;

const ResetPasswordForm: FC = (props: ResetPasswordFormProps) => {
  const { handleFormSubmit, initialValues, hasError, errorMsg } = props;
  const [hasValidPassword, setHasValidPassword] = useState(false);
  const { t } = useTranslation('translations', { keyPrefix: 'Login.ResetPassword.Page' });

  const submitHandler = (values: PasswordFeilds, actions: any) => {
    if (hasValidPassword) {
      handleFormSubmit(values, actions);
    }
  };

  return (
    <>
      <Box flx="col" width="100%">
        <Box mb="sm" flx="col" ai="center" height="auto">
          <Title title={t('title')} bold size="xsm" />
        </Box>
        <Formik
          initialValues={initialValues}
          validationSchema={ResetPasswordValidationSchema()}
          onSubmit={submitHandler}
        >
          {({ values, handleChange, handleBlur, handleSubmit, errors, touched, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <Box mb="sm" flx="col" height="auto">
                <TextField
                  key="Password"
                  name="Password"
                  placeholder={t('inputPlaceholder')}
                  preset="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Password}
                  variant="border"
                  height="50px"
                  error={errors.Password && touched.Password ? errors.Password : null}
                />
              </Box>
              <Box jc="fe" flx="col" height="auto" pb="md">
                <PasswordValidationWidget password={values.Password} onValidate={setHasValidPassword} />
              </Box>
              {hasError && (
                <div className={styles.errorMSG} style={{ paddingBottom: 15, paddingTop: 0 }}>
                  {errorMsg}
                </div>
              )}
              <Box jc="fe" flx="col" height="auto">
                <Button
                  id="reset-password-submit"
                  label={t('submitButton')}
                  type="submit"
                  size="xlg"
                  textSize={1}
                  isDisabled={isSubmitting}
                />
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </>
  );

  function ResetPasswordValidationSchema() {
    return Yup.object().shape({
      Password: Yup.string().label(t('passwordLabel')).required(),
    });
  }
};

export default ResetPasswordForm;
